import Inbox from '@crehana/compass.icons.outline/Inbox';
import { useTranslation } from '@crehana/i18n';
import locales from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TableEmptyWithoutFilters = function TableEmptyWithoutFilters(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? Inbox : _ref$icon,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  var Icon = icon;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-0.8",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-[6rem] tw-aspect-square tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-700",
      children: /*#__PURE__*/_jsx(Icon, {
        className: "tw-text-neutral-light-600 dark:tw-text-neutral-dark-200",
        size: 24
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-space-y-0.4 tw-flex tw-flex-col tw-items-center tw-justify-center",
      children: [/*#__PURE__*/_jsx("p", {
        className: "tw-font-subtitle5 tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
        children: title !== null && title !== void 0 ? title : t.TABLE_STATE_EMPTY_WITHOUT_FILTERS
      }), /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-w-2/3 tw-min-w-28",
        children: subtitle !== null && subtitle !== void 0 ? subtitle : t.TABLE_STATE_EMPTY_WITHOUT_FILTERS_SUBTITLE
      })]
    }), children]
  });
};